
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"fill":"#00579F","d":"M8.667 12.899h-1.62L8.06 6.123h1.62l-1.013 6.776zm5.873-6.611A3.731 3.731 0 0013.086 6c-1.6 0-2.726.923-2.733 2.242-.013.973.807 1.514 1.42 1.838.627.332.84.548.84.844-.007.454-.507.663-.973.663-.647 0-.994-.108-1.52-.36l-.214-.109-.226 1.521c.38.188 1.08.354 1.807.361 1.7 0 2.806-.908 2.82-2.314.006-.772-.427-1.363-1.36-1.846-.567-.31-.914-.519-.914-.836.006-.288.293-.584.933-.584.527-.014.914.123 1.207.26l.146.072.22-1.464zm2.153 4.21c.134-.389.647-1.895.647-1.895-.007.014.133-.397.213-.65l.113.585s.307 1.622.374 1.96h-1.347zm2-4.375H17.44c-.387 0-.68.122-.847.562L14.187 12.9h1.7l.34-1.016h2.08L18.5 12.9H20l-1.307-6.776zm-13 0l-1.586 4.62-.174-.937c-.293-1.08-1.213-2.256-2.24-2.84l1.454 5.926H4.86l2.547-6.77H5.693z"}}),_c('path',{attrs:{"fill":"#FAA61A","d":"M2.633 6.123H.027L0 6.26c2.033.562 3.38 1.918 3.933 3.547l-.566-3.115c-.094-.432-.38-.555-.734-.57z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    